function getFields({ application }, type, index = 1) {
  if (type === 'details') return application.currentApplicant[type];
  else if (type === 'swapReason') return application.currentApplicant[type];
  return application.currentApplicant[type][`${type.slice(0, -1)}${index}`];
}

export default { getFields };



// WEBPACK FOOTER //
// ./src/features/Application/getters.js